import { useEffect } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { Messages } from "namirasoft-account-client";
import { NSLoading } from "namirasoft-site-react";
import { AccountRoutes } from "../AccountRoutes";
import { AccountRouterProps } from "../AccountRouterProps";

interface LogoutPageProps extends NSARouterMakerResult, Partial<AccountRouterProps>
{ }

function LogoutPage(props: LogoutPageProps) 
{
    let onLogout = (redirect: boolean) =>
    {
        if (window.opener)
        {
            let token = props.account.token_manager?.getValue();
            window.opener.postMessage(JSON.stringify(Messages.logout(token ?? "")), "*");
            window.close();
        }
        else if (redirect)
            props.url.redirect(AccountRoutes.Home, {});
    };

    useEffect(() =>
    {
        props.account.server.ignore401 = true;
        props.account.server.session.Logout({ onError: () => { } }).then(() =>
        {
            onLogout(true);
        }).catch(() =>
        {
            onLogout(true);
        });
        // eslint-disable-next-line
    }, []);

    return <NSLoading
        title="Loggin out..."
    />;
}

export default LogoutPage;